import axios from 'axios';

export const equipmentItemApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/equipment-item`,
    headers: {
        'Content-Type': 'application/json'
    }
})